import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'workers_are_paid_direct_deposit_into_bank_account'

export const dataPointDefinition = {
  retracedId: 'workers_are_paid_direct_deposit_into_bank_account',
  name: 'If workers are paid by direct deposit into a bank account, do they have sole control of the bank account once opened?',
  description:
    '"Sole control of the account" refers to the fact that only the worker has control and access to the bank account. Management does not have any control or access.',
  meta: {
    slcpMeta: {
      key: 'wb-15--1',
      number: 'WB-WAGE-105',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-15--1', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34890,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
